import React, { useEffect, useState } from 'react';
import { AiOutlineLogout } from 'react-icons/ai';
import { RiUserAddFill } from 'react-icons/ri';
import { useParams, useNavigate } from 'react-router-dom';
import { GoogleLogout } from 'react-google-login';
import { v4 as uuidv4 } from 'uuid';

import { friendsQuery, userCreatedPinsQuery, userQuery, userSavedPinsQuery } from '../utils/data';
import { client } from '../client';
import MasonryLayout from './MasonryLayout';
import Spinner from './Spinner';

const activeBtnStyles = 'bg-red-500 text-white font-bold p-2 rounded-full w-20 outline-none';
const notActiveBtnStyles = 'bg-primary mr-4 text-black font-bold p-2 rounded-full w-20 outline-none';

const UserProfile = ({ save }) => {

  const [user, setUser] = useState();
  const [myProfile, setMyProfile] = useState();
  const [pins, setPins] = useState();
  const [text, setText] = useState(save ? 'Saved' : 'Created');
  const [activeBtn, setActiveBtn] = useState(save ? 'saved' : 'created');
  const navigate = useNavigate();
  const { userId } = useParams();
  const [following, setFollowing] = useState(false);

  const User = localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : localStorage.clear();
  // console.log("this is myProfile ",myProfile);
  // console.log("this is user ",user);

  useEffect(() => {
    const query = friendsQuery(User.googleId);
    client.fetch(query).then((data) => {
      setMyProfile(data[0]);
    });
  }, []);

  useEffect(() => {
    const query = userQuery(userId);
    client.fetch(query).then((data) => {
      setUser(data[0]);
    });
    
  }, [userId]);

  useEffect(() => {
    // console.log(myProfile);
    if(myProfile?.friend){
      const friends = myProfile?.friend;
      friends?.map((data) => {
        if(data?.friendId === userId)setFollowing(true);
      })

    }
  }, [myProfile]);

  useEffect(() => {
    if (text === 'Created') {
      const createdPinsQuery = userCreatedPinsQuery(userId);

      client.fetch(createdPinsQuery).then((data) => {
        setPins(data);
      });
    } else {
      const savedPinsQuery = userSavedPinsQuery(userId);

      client.fetch(savedPinsQuery).then((data) => {
        setPins(data);
      });
    }
  }, [text, userId]);

  const logout = () => {
    localStorage.clear();

    navigate('/login');
  };

  const handleAddFriend = ()=>{
    if(following)return;
    setFollowing(true);
    client
      .patch(myProfile?._id)
      .setIfMissing({ friend: [] })
      .insert('after', 'friend[-1]', [{
        name: user?.userName,
        image: user?.image,
        friendId: user?._id,
        _key: uuidv4(),
      }])
      .commit()
      .then(() => {
        console.log("ok");
      });

  }

  if (!user) return <Spinner message="Loading profile" />;

  return (
    <div className="relative pb-2 h-full justify-center items-center">
      <div className="flex flex-col pb-5">
        <div className="relative flex flex-col mb-7">
          <div className="flex flex-col justify-center items-center">
            <img
              className=" w-full h-370 2xl:h-400 shadow-lg"
              src="https://source.unsplash.com/1600x900/?nature,photography,technology"
              alt="user-pic"
            />
            <img
              className="rounded-full w-20 h-20 -mt-10 shadow-xl object-cover"
              src={user.image}
              alt="user-pic"
            />
          </div>
          <h1 className="font-bold text-3xl text-center mt-3">
            {user.userName}
          </h1>
          <div className="absolute top-0 z-1 right-0 p-2">
            {userId === User.googleId && (
              <GoogleLogout
                clientId={`${process.env.REACT_APP_GOOGLE_API_TOKEN}`}
                render={(renderProps) => (
                  <button
                    type="button"
                    className=" bg-white p-2 rounded-full cursor-pointer outline-none shadow-md"
                    onClick={renderProps.onClick}
                    disabled={renderProps.disabled}
                  >
                    <AiOutlineLogout color="red" fontSize={21} />
                  </button>
                )}
                onLogoutSuccess={logout}
                cookiePolicy="single_host_origin"
              />
            )}
          </div>
        </div>
        <div className="text-center mb-7">
          <button
            type="button"
            onClick={(e) => {
              setText(e.target.textContent);
              setActiveBtn('created');
            }}
            className={`${activeBtn === 'created' ? activeBtnStyles : notActiveBtnStyles}`}
          >
            Created
          </button>
          <button
            type="button"
            onClick={(e) => {
              setText(e.target.textContent);
              setActiveBtn('saved');
            }}
            className={`${activeBtn === 'saved' ? activeBtnStyles : notActiveBtnStyles}`}
          >
            Saved
          </button>

          {userId !== myProfile?.userId && <button className='ml-2'>
            <div 
            onClick={handleAddFriend}
            className="flex justify-center items-center bg-blue-700 hover:bg-blue-800 text-white font-bold py-2 px-4 rounded-3xl">

              <RiUserAddFill className='m-1'/> 
              {following ? "Friend" : "Add Friend"}
            </div>
          </button> }

        </div>

        <div className="px-2">
          <MasonryLayout pins={pins} />
        </div>

        {pins?.length === 0 && (
          <div className="flex justify-center font-bold items-center w-full text-1xl mt-2">
            No Pins Found!
          </div>
        )}
      </div>

    </div>
  )
}

export default UserProfile  